<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import { TButton } from '@/components/ui/button';

const { triggerClass = '', triggerCallback = () => {} } = defineProps<{
  triggerClass?: string;
  triggerCallback?: () => void;
}>();

const router = useRouter();
const { t: $t } = useI18n();

const startKycProcess = () => {
  triggerCallback?.();
  return router.push('/kyc');
};
</script>

<template>
  <TButton variant="secondary" size="sm" :class="triggerClass" @click="startKycProcess">
    {{ $t('features.kyc.button') }}
  </TButton>
</template>
